import React      from "react";
import List       from "../components/list";
import ListItem   from "../components/list-item";
import Spinner    from "../components/spinner";
import View       from "./view";
import messages   from "../../../messages";
import config     from "../../../config";
import { POINT_TYPE_FREE } from "../../../point-types";

export default class TimeView extends View {
    static get title () {
        return "выберите удобное время приема";
    }

    static get titleShort() {
        return "время";
    }

    static get propTypes() {
        return Object.assign({}, super.propTypes, {
            scheduleScroll: React.PropTypes.number.isRequired,
            clinic: React.PropTypes.number.isRequired,
            doctor: React.PropTypes.string.isRequired,
        });
    }

    constructor(props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            items: null
        });

        this._isMounted = false;
    }

    fetchData() {
        this.hideErrorMessage();
        this.setState({
            items: null
        });

        const url = `${config.dataUrl}api.php?function=schedule`  +
            `&clinic=${this.props.clinic}` +
            `&service=${this.props.service}` +
            `&doctor=${this.props.doctor}` +
            `&length=${config.scheduleLength}` +
            `&scroll=${this.props.scheduleScroll}`;

        fetch(url).then((response) => {
            return response.json();
        }).then((responseJson) => {
            if (this._isMounted === true) {
                const dates = responseJson.dates;
                const columnIndex = dates.indexOf(this.props.date);

                if (columnIndex === -1) {
                    throw new ReferenceError("Дата не найдена.");
                }

                const column = responseJson.grid[columnIndex];
                this.setState({
                    items: column
                });
            }
        }).catch((error) => {
            if (this._isMounted === true) {
                this.showErrorMessage(messages["REQUEST_FAILED"]);
            }
        });
    }

    componentDidMount() {
        this.fetchData();
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleRetryClick() {
        this.fetchData();
    }

    renderContent() {
        if (this.state.isErrorMessageVisible === true) {
            return this.renderErrorMessage();
        }

        if (this.state.items === null) {
            return <Spinner />;
        }

        const elements = this.state.items.map((item, key) => {
            if (item.status === POINT_TYPE_FREE) {
                return (
                    <ListItem
                        key={key}
                        isActive={true}
                        hasStatusIndicator={true}
                        onClick={() => this.props.gotoNextView({
                            breadcrumbName: item.time,
                            nextView: "ContactsView",
                            props: {
                                time: item.time,
                            }
                        })}>

                        {item.time}
                    </ListItem>
                );
            } else {
                return null;
            }
        });

        return <List>{elements}</List>;
    }

    render() {
        return (
            <div className="appointment-view appointment-view--time">
                {this.renderContent()}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/time.js
 **/